import { useEffect } from "react";
import { callAPIInterface, getCurrencyAmount } from "../components/constants";
import { sats } from "../components/messages";

function useTransactionMinMaxAmount({
  data,
  currency,
  currencyExchangeRate,
  isOnchainMethod,
  isLnUrlMethodSend,
  isLnUrlMethodReceive,
  setMaxTransactionAmt,
  setMinTransactionAmt,
  setIsSendMax,
  setSendMaxAmount,
}) {
  const fetchSendMaxAmount = async () => {
    try {
      const response = await callAPIInterface(
        "GET",
        "/withdraws/lightning-max-amount"
      );
      setSendMaxAmount(getCurrencyAmount(response?.amount, currency));
    } catch (err) {}
  };
  useEffect(() => {
    if (!isOnchainMethod) {
      fetchSendMaxAmount();
    }

    if (isLnUrlMethodSend || isLnUrlMethodReceive) {
      const maxTxnAmt = isLnUrlMethodSend
        ? currency === sats
          ? data?.max_sendable
          : data?.max_sendable * currencyExchangeRate
        : data?.max_withdrawable;

      const minTxnAmt = isLnUrlMethodSend
        ? currency === sats
          ? data?.min_sendable
          : data?.min_sendable * currencyExchangeRate
        : data?.min_withdrawable;

      setMaxTransactionAmt(maxTxnAmt);
      setMinTransactionAmt(minTxnAmt);
    }

    return () => {
      setIsSendMax?.(false);
    };
  }, []);
}

export default useTransactionMinMaxAmount;
